export const NAME = "disclaimer";

export const STEP_DISCLAIMER_TEXT = `${NAME}/STEP_DISCLAIMER_TEXT`;
export const STEP_DISCLAIMER_DECLINED = `${NAME}/STEP_DISCLAIMER_DECLINED`;
